export default "__VITE_ASSET__CppCHVkB__"